import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Popover from 'react-popover'
import classNames from 'classnames'
import debounce from 'lodash/debounce'
import { isIE, isEdge } from 'react-device-detect'
import { withTranslation } from 'react-i18next'

import LikeIcon from 'app/components/SVGS/LikeIcon'
import { EMOJIS } from 'app/constants/feed'

import './styles.scss'
const bc = 'feed-emojis'
const hasMouseEvents = !isEdge && !isIE

class FeedEmojis extends Component {
  state = {
    showTooltip: false,
  }

  tooltipHovered = false

  onButtonMouseEnter = debounce(() => this.onShowTooltip(), 400)

  onButtonMouseLeave = debounce(() => {
    if (!this.tooltipHovered) {
      this.onHideTooltip()
    }
  }, 400)

  onTooltipMouseEnter = () => {
    this.tooltipHovered = true
  }

  onTooltipMouseLeave = () => {
    this.tooltipHovered = false
    this.onHideTooltip()
  }

  onHideTooltip = () => {
    this.setState({ showTooltip: false })
  }

  onShowTooltip = () => {
    this.setState({ showTooltip: true })
  }

  onToggleTooltip = () => {
    this.setState({ showTooltip: !this.state.showTooltip })
  }

  onEmojiClickHandler = emojiName => {
    this.onHideTooltip()
    this.props.setReaction(emojiName)
  }

  renderEmojies = () => (
    <div
      className={`${bc}__emojis-list`}
      onMouseEnter={this.onTooltipMouseEnter}
      onMouseLeave={hasMouseEvents && this.onTooltipMouseLeave}
    >
      {EMOJIS.map((emoji, index) => (
        <div className={`${bc}__emoji`} onClick={() => this.onEmojiClickHandler(emoji.name)} key={'emoji' + index}>
          {React.createElement(emoji.icon)}
        </div>
      ))}
    </div>
  )

  render() {
    const { t } = this.props
    return (
      <div className={bc}>
        <Popover
          isOpen={this.state.showTooltip}
          preferPlace="right"
          place={null}
          tipSize={2}
          body={this.renderEmojies()}
          className={`${bc}__popup`}
          onOuterAction={this.onHideTooltip}
        >
          <div
            className={classNames(`${bc}__button`, {
              [`${bc}__button--active`]: !this.props.hasReacted,
            })}
            onMouseEnter={hasMouseEvents && this.onButtonMouseEnter}
            onMouseLeave={hasMouseEvents && this.onButtonMouseLeave}
            onClick={this.onToggleTooltip}
          >
            <LikeIcon />
            <span className={`${bc}__text`}>{t('Like')}</span>
          </div>
        </Popover>
      </div>
    )
  }
}

FeedEmojis.propTypes = {
  setReaction: PropTypes.func.isRequired,
  hasReacted: PropTypes.bool,
}

export default withTranslation('user')(FeedEmojis)
